import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { SalarieCompetenceDto } from '../../../dto/GenApi.iNotPaie.Dto/SalarieCompetenceDto';
import { LangueDto } from '../../../dto/GenApi.iNotPaie.Dto/LangueDto';
import moment from 'moment';
import { EventBus } from '../../Controls/EventBus';
import { ServicesFactoryInstance } from '../../Controls/ServicesFactory';
import $ from 'jquery';
import ModalAjouterLangue from './modals/ajouterLangue/ajouterLangue';
import ModalAjouterDiplome from './modals/ajouterDiplome/ajouterDiplome';
import ModalAjouterExperience from './modals/ajouterExperience/ajouterExperience';
import ModalAjouterFormation from './modals/ajouterFormation/ajouterFormation';
import { DiplomeDto } from '../../../dto/GenApi.iNotPaie.Dto/DiplomeDto';
import { ExperienceDto } from '../../../dto/GenApi.iNotPaie.Dto/ExperienceDto';
import { FormationDto } from '../../../dto/GenApi.iNotPaie.Dto/FormationDto';
import { ParametresInstance } from '../../Controls/Parameters';
import EventConstants, { RoleConstants } from '../../Controls/EventConstants';
import { NotificationServiceInstance } from '../../../shared/services/notification.service';

interface salarieChargeInfos {
	errorMessage: string[];
	isModified: boolean;
	salarieCourant?: SalarieCompetenceDto;
	dateEntree: string;
	dateRetraite: string;
	dateAnciennete: string;
}

@Component({
	components: {
		ModalAjouterLangue: require('./modals/ajouterLangue/ajouterLangue.vue.html'),
		ModalAjouterDiplome: require('./modals/ajouterDiplome/ajouterDiplome.vue.html'),
		ModalAjouterExperience: require('./modals/ajouterExperience/ajouterExperience.vue.html'),
		ModalAjouterFormation: require('./modals/ajouterFormation/ajouterFormation.vue.html')
	}
})

export default class CompetencesSalarieComponent extends Vue {
	public canModify = false;

	public currentId = 0;
	public dataReady = false;
	public isModified = false;
	public errorMessage: string[] = [];
	public salarieCourant?: SalarieCompetenceDto = undefined;
	public salarieCharges: salarieChargeInfos[] = [];

	public modalAjouterLangue?: ModalAjouterLangue = undefined;
	public modalAjouterDiplome?: ModalAjouterDiplome = undefined;
	public modalAjouterExperience?: ModalAjouterExperience = undefined;
	public modalAjouterFormation?: ModalAjouterFormation = undefined;
	public dateEntree = '';
	public dateAnciennete = '';
	public dateRetraite = '';
	public idPersonneAdded = -1;
	public isInitialized = false;

	public init(): void {
		if (this.isInitialized || ParametresInstance.utilisateurCourant == undefined) {
			return;
		}

		this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]);

		this.modalAjouterLangue = this.$refs.modalAjouterLangue as ModalAjouterLangue;
		this.modalAjouterDiplome = this.$refs.modalAjouterDiplome as ModalAjouterDiplome;
		this.modalAjouterExperience = this.$refs.modalAjouterExperience as ModalAjouterExperience;
		this.modalAjouterFormation = this.$refs.modalAjouterFormation as ModalAjouterFormation;
		this.fetchData();

		this.isInitialized = true;
	}

	public mounted(): void {
		this.isInitialized = false;
		// On ne sait pas dans quel ordre ça peut arriver (1er appel ou refresh de la page...)
		ServicesFactoryInstance.HeaderService.getHeaderInfos(() => {
			EventBus.$on(EventConstants.UTILISATEUR_CHANGED, () => {
				this.init();
			});
			this.init();
		});
	}

	public fetchData(): void {
		if (this.currentId < 1) {
			return;
		}
		this.dataReady = false;
		if (this.salarieCharges[this.currentId] == null || !this.salarieCharges[this.currentId].isModified) {
			ServicesFactoryInstance.SalarieService.getSalarieCompetences(this.currentId, data => {
				this.setData(data);
			});
		} else {
			this.dateEntree = this.salarieCharges[this.currentId].dateEntree;
			this.dateAnciennete = this.salarieCharges[this.currentId].dateAnciennete;
			this.dateRetraite = this.salarieCharges[this.currentId].dateRetraite;
			this.errorMessage = this.salarieCharges[this.currentId].errorMessage;
			this.isModified = this.salarieCharges[this.currentId].isModified;
			this.salarieCourant = this.salarieCharges[this.currentId].salarieCourant;
			this.dataReady = true;
		}
	}

	public reloadData(id: number): void {
		if (this.currentId > 0) {
			this.salarieCharges[this.currentId] = {
				dateEntree: this.dateEntree,
				dateAnciennete: this.dateAnciennete,
				dateRetraite: this.dateRetraite,
				errorMessage: this.errorMessage,
				salarieCourant: this.salarieCourant,
				isModified: this.isModified
			};
		}
		this.currentId = id;
		this.fetchData();
	}

	public setData(data: SalarieCompetenceDto): void {
    	this.salarieCourant = data;
		this.dateEntree = moment.utc(this.salarieCourant.DateEntree).format("YYYY-MM-DD");
		this.dateAnciennete = moment.utc(this.salarieCourant.DateAnciennete).format("YYYY-MM-DD");
    	this.dateRetraite = moment.utc(this.salarieCourant.DateRetraite).format("YYYY-MM-DD");
    	this.dataReady = true;
	}

	public enregistrer(): boolean {
		if (this.salarieCourant == undefined) {
			return false;
		}

		this.salarieCourant.DateEntree = moment.utc(this.dateEntree).toDate();
		this.salarieCourant.DateAnciennete = moment.utc(this.dateAnciennete).toDate();
		this.salarieCourant.DateRetraite = moment.utc(this.dateRetraite).toDate();
		this.dataReady = false;

		ServicesFactoryInstance.SalarieService.updateSalarieCompetence(this.salarieCourant, data => {
			this.setData(data);
			this.$emit('isModified', false);
			this.isModified = false;
			NotificationServiceInstance.SendSuccess("L'enregistrement du salarié s'est correctement déroulé !");
		}, () => {
			this.dataReady = true;
		});

		return false;
	}

	// MODALS

	public addLangue(): void {
		this.modalAjouterLangue = this.$refs.modalAjouterLangue as ModalAjouterLangue;

		if (this.modalAjouterLangue == undefined) {
			return;
		}

		this.modalAjouterLangue.initialize({ Id: this.idPersonneAdded }, true, this.salarieCourant);
		$('#modalAjouterLangue').modal('show');
	}

	public addDiplome(): void {
		this.modalAjouterDiplome = this.$refs.modalAjouterDiplome as ModalAjouterDiplome;

		if (this.modalAjouterDiplome == undefined) {
			return;
		}

		this.modalAjouterDiplome.initialize({ Id: this.idPersonneAdded }, true, this.salarieCourant);
		$('#modalAjouterDiplome').modal('show');
	}

	public addExperience(): void {
		this.modalAjouterExperience = this.$refs.modalAjouterExperience as ModalAjouterExperience;

		if (this.modalAjouterExperience == undefined) {
			return;
		}

		this.modalAjouterExperience.initialize({ Id: this.idPersonneAdded }, true, this.salarieCourant);
		$('#modalAjouterExperience').modal('show');
	}

	public addFormation(): void {
		this.modalAjouterFormation = this.$refs.modalAjouterFormation as ModalAjouterFormation;

		if (this.modalAjouterFormation == undefined) {
			return;
		}

		this.modalAjouterFormation.initialize({ Id: this.idPersonneAdded }, true, this.salarieCourant);
		$('#modalAjouterFormation').modal('show');
	}

	// ---------------------------------------------------------------------- LANGUES

	public ajoutLangue(e: any): void {
		if (e == undefined || e.langue == undefined || this.salarieCourant == undefined) {
			return;
		}

		this.salarieCourant.Langues.push(e.langue);
		this.modify();
	}

	public editLangue(l: LangueDto): void {
		this.modalAjouterLangue = this.$refs.modalAjouterLangue as ModalAjouterLangue;

		if (this.modalAjouterLangue == undefined) {
			return;
		}

		this.modalAjouterLangue.initialize(l, false, this.salarieCourant);

		$('#modalAjouterLangue').modal('show');
	}

	public deleteLangue(l: LangueDto): void {
		if (this.salarieCourant == undefined) {
			return;
		}

		this.salarieCourant.Langues = this.salarieCourant.Langues.filter(c => (c.Id != l.Id && c.Id != 0) || (c.Id == 0 && l.Id == 0 && c.Nom != l.Nom && c.Lu != l.Lu && c.Parler != l.Parler && c.Juridique != l.Juridique));
		this.modify();
	}

	public modificationLangue(e: any): void {
		if (e == undefined || e.langue == undefined || this.salarieCourant == undefined) {
			return;
		}

		let langueToUpdater: LangueDto = { Id: 0 };
		langueToUpdater = this.salarieCourant.Langues.filter(p => p.Id == e.langue.Id)[0];

		if (langueToUpdater != undefined && e != undefined) {
			langueToUpdater.Id = e.langue.Id;
			langueToUpdater.Nom = e.langue.Nom;
			langueToUpdater.Lu = e.langue.Lu;
			langueToUpdater.Parler = e.langue.Parler;
			langueToUpdater.Juridique = e.langue.Juridique;
		}

		this.modify();
	}

	// ---------------------------------------------------------------------- DIPLOMES

	public ajoutDiplome(e: any): void {
		if (e == undefined || e.diplome == undefined || this.salarieCourant == undefined) {
			return;
		}

		this.salarieCourant.Diplomes.push(e.diplome);
		this.modify();
	}

	public editDiplome(d: DiplomeDto): void {
		this.modalAjouterDiplome = this.$refs.modalAjouterDiplome as ModalAjouterDiplome;

		if (this.modalAjouterDiplome == undefined) {
			return;
		}

		this.modalAjouterDiplome.initialize(d, false, this.salarieCourant);

		$('#modalAjouterDiplome').modal('show');
	}

	public deleteDiplome(d: DiplomeDto): void {
		if (this.salarieCourant == undefined) {
			return;
		}

		this.salarieCourant.Diplomes = this.salarieCourant.Diplomes.filter(c => (c.Id != d.Id && c.Id != 0) ||
			(c.Id == 0 && d.Id == 0 &&
				c.Annee != d.Annee &&
				c.Habilitation != d.Habilitation &&
				c.Nom != d.Nom &&
				c.Nomination != d.Nomination &&
				c.Semestrialite != d.Semestrialite &&
				c.Seminaire != d.Seminaire
			));
		this.modify();
	}

	public modificationDiplome(e: any): void {
		if (e == undefined || e.diplome == undefined || this.salarieCourant == undefined) {
			return;
		}

		let diplomeToUpdater: DiplomeDto = { Id: 0 };
		diplomeToUpdater = this.salarieCourant.Diplomes.filter(p => p.Id == e.diplome.Id)[0];

		if (diplomeToUpdater != undefined && e != undefined) {
			diplomeToUpdater.Id = e.diplome.Id;
			diplomeToUpdater.Annee = e.diplome.Annee;
			diplomeToUpdater.Habilitation = e.diplome.Habilitation;
			diplomeToUpdater.Nom = e.diplome.Nom;
			diplomeToUpdater.Nomination = e.diplome.Nomination;
			diplomeToUpdater.Semestrialite = e.diplome.Semestrialite;
			diplomeToUpdater.Seminaire = e.diplome.Seminaire;
		}

		this.modify();
	}

	// ---------------------------------------------------------------------- EXPERIENCES

	public ajoutExperience(e: any): void {
		if (e == undefined || e.experience == undefined || this.salarieCourant == undefined) {
			return;
		}

		this.salarieCourant.Experiences.push(e.experience);
		this.modify();
	}

	public editExperience(e: ExperienceDto): void {
		this.modalAjouterExperience = this.$refs.modalAjouterExperience as ModalAjouterExperience;

		if (this.modalAjouterExperience == undefined) {
			return;
		}

		this.modalAjouterExperience.initialize(e, false, this.salarieCourant);

		$('#modalAjouterExperience').modal('show');
	}

	public deleteExperience(e: ExperienceDto): void {
		if (this.salarieCourant == undefined) {
			return;
		}

		this.salarieCourant.Experiences = this.salarieCourant.Experiences.filter(c => (c.Id != e.Id && c.Id != 0) ||
			(c.Id == 0 && e.Id == 0 &&
				c.DateDebut != e.DateDebut &&
				c.DateFin != e.DateFin &&
				c.Employeur != e.Employeur &&
				c.Poste != e.Poste
			));
		this.modify();
	}

	public modificationExperience(e: any): void {
		if (e == undefined || e.experience == undefined || this.salarieCourant == undefined) {
			return;
		}

		let experienceToUpdater: ExperienceDto = { Id: 0 };
		experienceToUpdater = this.salarieCourant.Experiences.filter(p => p.Id == e.experience.Id)[0];

		if (experienceToUpdater != undefined && e != undefined) {
			experienceToUpdater.Id = e.experience.Id;
			experienceToUpdater.DateDebut = e.experience.DateDebut;
			experienceToUpdater.DateFin = e.experience.DateFin;
			experienceToUpdater.Employeur = e.experience.Employeur;
			experienceToUpdater.Poste = e.experience.Poste;
		}

		this.modify();
	}

	// ---------------------------------------------------------------------- FORMATIONS

	public ajoutFormation(e: any): void {
		if (e == undefined || e.formation == undefined || this.salarieCourant == undefined) {
			return;
		}

		this.salarieCourant.Formations.push(e.formation);
		this.modify();
	}

	public editFormation(e: FormationDto): void {
		this.modalAjouterFormation = this.$refs.modalAjouterFormation as ModalAjouterFormation;

		if (this.modalAjouterFormation == undefined) {
			return;
		}

		this.modalAjouterFormation.initialize(e, false, this.salarieCourant);

		$('#modalAjouterFormation').modal('show');
	}

	public deleteFormation(e: FormationDto): void {
		if (this.salarieCourant == undefined) {
			return;
		}

		this.salarieCourant.Formations = this.salarieCourant.Formations.filter(c => (c.Id != e.Id && c.Id != 0) ||
			(c.Id == 0 && e.Id == 0 &&
				c.DateDebut != e.DateDebut &&
				c.DateFin != e.DateFin &&
				c.Acquisition != e.Acquisition &&
				c.ProchaineDate != e.ProchaineDate &&
				c.Intitule != e.Intitule &&
				c.NombreJours != e.NombreJours &&
				c.Plan != e.Plan
			));
		this.modify();
	}

	public modificationFormation(e: any): void {
		if (e == undefined || e.formation == undefined || this.salarieCourant == undefined) {
			return;
		}

		let formationToUpdater: FormationDto = { Id: 0 };
		formationToUpdater = this.salarieCourant.Formations.filter(p => p.Id == e.formation.Id)[0];

		const f: FormationDto = e.formation as FormationDto;

		if (formationToUpdater != undefined && e != undefined) {
			formationToUpdater.Id = f.Id;
			formationToUpdater.DateDebut = f.DateDebut;
			formationToUpdater.DateFin = f.DateFin;
			formationToUpdater.Acquisition = f.Acquisition;
			formationToUpdater.ProchaineDate = f.ProchaineDate;
			formationToUpdater.Intitule = f.Intitule;
			formationToUpdater.NombreJours = f.NombreJours;
			formationToUpdater.Plan = f.Plan;
		}

		this.modify();
	}

	// ---------------------------------------------------------------------- BUTTON

	public annuler(): void {
		if (this.salarieCharges[this.currentId] != undefined) {
			this.salarieCharges[this.currentId].isModified = false;
		}
		this.fetchData();
		this.isModified = false;
		this.$emit('isModified', false);
	}

	public modify(): void {
		this.isModified = false;
		this.isModified = true;
		this.$emit('isModified', true);
	}

	public refreshCompetences(): void {
		this.fetchData();
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/competences/competences.ts